import { render } from "./ImportTrainees.vue?vue&type=template&id=d0744a9c&scoped=true"
import script from "./ImportTrainees.vue?vue&type=script&lang=js"
export * from "./ImportTrainees.vue?vue&type=script&lang=js"

import "./ImportTrainees.vue?vue&type=style&index=0&id=d0744a9c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0744a9c"]])

export default __exports__